const prefix = 'notifications/';

export const NOTIFICATIONS_LIST_TAG = `${prefix}`;

export default NOTIFICATIONS_LIST_TAG;
